import React from "react";
import { t } from "../utils/i18n";
import {
  Container,
  CVButton,
  Greeting,
  ProfilePic,
  ProfileWrapper,
  ProfileWrapperAbout,
  Status,
} from "../styles/home";
import ProfileImg from "../assets/profile.png";
import SendIcon from "@mui/icons-material/Send";
import { Link } from "react-router-dom";
import { AboutContainer, ProfileAboutPic, Resume } from "../styles/about";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import Skill from "./skills";
import ResumeSection from "../components/resume";

const About = () => {
  return (
    <div>
      <AboutContainer>
        <ProfileAboutPic src={ProfileImg} style={{ maxWidth: "400px" }} />
        <Greeting>
          <h1>
            I'm Ilyosjon Inomjonov, <br /> full-stack web-developer.
          </h1>
          <p>
            {t("label.paragraph.first")}
            <br /> <br />
            {t("label.paragraph.second")}
          </p>
          <p>
            <Status></Status> Available for Freelancing
          </p>
          <Link style={{ textDecoration: "none" }} to={"/contact"}>
            <CVButton style={{ maxWidth: "170px" }}>
              <p>
                Get in touch{" "}
                <div style={{ transform: "rotate(0deg)" }}>
                  <SendIcon />
                </div>
              </p>
            </CVButton>
          </Link>
        </Greeting>
      </AboutContainer>
      <Skill />
      <ResumeSection />
    </div>
  );
};

export default About;
